import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const locations = [
    {
      country: 'Uganda',
      address: 'Innovation Village, Ntinda Complex, Block D, Ntinda, Kampala, Uganda',
      phone: '+256 200 930 707',
      email: 'hello@blue-vantage.com'
    },
    {
      country: 'Kenya',
      address: 'Chaka Road, Nairobi Atrium building 5th Floor, Westlands Kilimani, Nairobi',
      phone: '+256 200 930 707',
      email: 'hello@blue-vantage.com'
    },
    {
      country: 'Tanzania',
      address: '84 Kinondoni Rd, Dar es Salaam 14110, Tanzania',
      phone: '+256 200 930 707',
      email: 'hello@blue-vantage.com'
    },
    {
      country: 'Ethiopia',
      address: '1110, 2219 Qelebet Menged, Addis Ababa, Ethiopia',
      phone: '+256 200 930 707',
      email: 'hello@blue-vantage.com'
    },
    {
      country: 'Mozambique',
      address: 'Tower - 6th floor, 141, Rani Av. Marginal, Maputo, Mozambique',
      phone: '+256 200 930 707',
      email: 'hello@blue-vantage.com'
    }
  ];

  const footerLinks = {
    'AI Agents': ['Voice Agent', 'Customer Service Agent', 'Sales Agent', 'Booking Agent', 'Lead Qualification'],
    'Platform': ['Agent Builder Studio', 'Analytics', 'Integrations', 'Security'],
    'Solutions': ['Retail & eCommerce', 'Financial Services', 'Healthcare', 'Travel & Hospitality', 'Telecommunications'],
    'Company': ['About Us', 'Careers', 'Blog', 'Contact Us', 'Partners']
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Logo and Tagline */}
        <div className="mb-12">
          <img 
            src="https://customer-assets.emergentagent.com/job_ff87029c-4a94-4b3a-94b0-df833d291323/artifacts/zao927uo_BVSL%20LOGO.png" 
            alt="Blue Vantage" 
            className="h-16 w-auto mb-4 brightness-0 invert"
          />
          <p className="text-xl font-medium text-white max-w-md">
            Simply Innovation...
          </p>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-white font-bold mb-4">{category}</h3>
              <ul className="space-y-3">
                {links.map((link, idx) => (
                  <li key={idx}>
                    <Link
                      to="#"
                      className="hover:text-blue-400 transition-colors duration-200"
                    >
                      {link}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Locations */}
        <div className="border-t border-gray-800 pt-12 mb-12">
          <h3 className="text-2xl font-bold text-white mb-8">Our Locations</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {locations.map((location, idx) => (
              <div key={idx} className="bg-gray-800 rounded-xl p-6 hover:bg-gray-750 transition-colors duration-300">
                <h4 className="text-xl font-bold text-white mb-4">{location.country}</h4>
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <MapPin className="w-5 h-5 text-blue-400 shrink-0 mt-1" />
                    <p className="text-gray-300">{location.address}</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <Phone className="w-5 h-5 text-blue-400" />
                    <a href={`tel:${location.phone}`} className="hover:text-blue-400 transition-colors">
                      {location.phone}
                    </a>
                  </div>
                  <div className="flex items-center gap-3">
                    <Mail className="w-5 h-5 text-blue-400" />
                    <a href={`mailto:${location.email}`} className="hover:text-blue-400 transition-colors">
                      {location.email}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Blue Vantage. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <Link to="#" className="hover:text-blue-400 transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-blue-400 transition-colors">Terms of Service</Link>
            <Link to="#" className="hover:text-blue-400 transition-colors">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;